/* src/sb-modules/Frontend-Settings-Menu-Module/settings-menu.component.scss */
.pointer {
  cursor: pointer;
}
.dropdown-item {
  color: #212529;
}
/*# sourceMappingURL=settings-menu.component.css.map */
